// extracted by mini-css-extract-plugin
export default {"searchBoxBorder":"WFMA0NU4MqJvAbzi3Nqi","searchBoxIcon":"njVHxSUi2Kg3rpiuZKQu"};